<template>
  <v-layout>
    <v-navigation-drawer
      v-model="panel.activated"
      :width="$isMobile ? '100%' : '50%'"
      right
      fixed
      :permanent="panel.activated"
      hide-overlay
      class="z-index--100">
      <div class="ma-3">
        <div class="d-flex">
          <v-btn
            dark
            fab
            x-small
            outlined
            color="primary"
            class="mr-3"
            @click="onCloseIngredientsDialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <div
            class="subtitle-1 primary--text mr-3">
            Producción de {{ (recipeModel) ? recipeModel.name : '' }}
          </div>
          <span class="subtitle-1">
            Total: ${{ recipeModel.cost | toFixNumber(2) | numberWithComma }}
          </span>
          <v-spacer />
          <v-btn
              color="black darken-1"
              @click="print"
              icon
            >
            <v-icon>mdi-printer</v-icon>
          </v-btn>
        </div>
        <v-row>
          <v-col md="12" class="d-print-none">
            <div class="subtitle">
                Modifica la producción
            </div>
            <v-form ref="ingredientForm" v-model="form.valid">
              <v-container grid-list-xl>
                <v-layout wrap>
                  <v-flex md6>
                    <v-text-field
                      :label="$t('production.labels.production')"
                      v-model.number="form.data.production"
                      outlined
                      dense
                      rounded
                    />
                  </v-flex>
                  <v-flex md6>
                    <v-select
                    ref="units"
                    :label="$t('production.labels.unit')"
                    v-model="form.data.unit"
                    :items="form.meta.units.data"
                    :disabled="form.meta.units.disabled"
                    placeholder="Selecciona una unidad"
                    item-text="name"
                    item-value="uuid"
                    @keyup.up="activateUnitsMenu"
                    @keyup.down="activateUnitsMenu"
                    outlined
                    dense
                    rounded
                    return-object
                    required>
                    </v-select>
                  </v-flex>
                </v-layout>
                <div class="d-flex justify-end d-print-none">
                  <v-btn
                    class="mr-3"
                    color="primary"
                    outlined
                    rounded
                    small
                    depressed
                    @click="cancel">
                    Cancelar
                  </v-btn>
                  <v-btn
                    color="primary"
                    rounded
                    small
                    depressed
                    @click="updateProduction">
                    {{ $t('ingredients.actions.save') }}
                  </v-btn>
                </div>
              </v-container>
            </v-form>
          </v-col>
          <v-col md="12">
            <v-data-table
              :loading-text="table.title"
              :server-items-length="table.total"
              :loading="table.loading"
              :headers="table.headers"
              :items="table.data"
              :items-per-page="table.limit"
              :page="table.page"
              @update:page="updatePage"
              @update:options="nextPage"
              class="elevation-1"
              dense>
              <template
                v-slot:item.name="{ item }">
                <div>
                  <v-tooltip right>
                    <template v-slot:activator="{ on }">
                      <v-btn text v-on="on">{{ item.name }}</v-btn>
                    </template>
                    <div
                      v-if="item.choice"
                      style="width: 100%"
                    >
                      ${{ item.choice.amount | toFixNumber(2) }} x {{ item.choice.unit.code }}
                    </div>
                    <div
                      v-else
                      style="width: 100%"
                    >
                      ${{ item.price | toFixNumber(2) }} x {{ item.unit.code }}
                    </div>
                  </v-tooltip>
                </div>
              </template>
              <template v-slot:item.price="{ item }">
                <div class="text-right">
                  ${{ item.price | toFixNumber(2) | numberWithComma }}
                </div>
              </template>
              <template v-slot:item.quantity="{ item }">
                <div class="text-right">
                  <v-edit-dialog
                    :return-value.sync="item.quantity"
                    large
                    @save="updateIngridient(item)"
                  >
                    <div>
                      {{ (item.quantity || 0) | toFixNumber(2) | numberWithComma }}
                      <v-icon
                        small
                        class="mr-2"
                      >
                        mdi-border-color
                      </v-icon>
                    </div>
                    <template v-slot:input>
                      <v-text-field
                        v-model.number="item.quantity"
                        label="Edit"
                        single-line
                        counter
                        autofocus
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </div>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </div>
    </v-navigation-drawer>
  </v-layout>
</template>

<script>
import { cloneDeep } from 'lodash'
import Recipe from '@/models/Recipe'

export default {
  name: 'Production',
  props: ['ingredientDialog', 'recipe'],
  data () {
    let recipeModel = new Recipe(this.recipe)

    return {
      panel: {
        activated: false
      },
      recipeModel,
      removeDialog: false,
      ingredientToRemove: {},
      table: {
        title: this.$i18n.t('ingredients.loading'),
        loading: true,
        headers: [
          { text: this.$i18n.t('ingredients.headers.name'), value: 'name' },
          { text: this.$i18n.t('ingredients.headers.quantity'), value: 'quantity' },
          { text: this.$i18n.t('ingredients.headers.baseUnit'), value: 'unit.name' },
          { text: this.$i18n.t('ingredients.headers.price'), value: 'price' }
        ],
        data: [],
        total: 0,
        limit: 15,
        page: 1
      },
      form: {
        valid: false,
        data: {
          unit: null,
          production: 0
        },
        meta: {
          units: {
            data: []
          }
        }
      },
      units: {
        loading: false,
        data: this.$store.state.login.units.data,
        total: 0
      },
      selectedRecipe: null
    }
  },
  watch: {
    ingredientDialog: function (val) {
      this.panel.activated = val
    },
    recipe: async function (val) {
      if (val) {
        this.recipeModel = new Recipe(val)
        this.selectedRecipe = val
        this.form.data.production = this.recipeModel.$.production
        this.form.data.unit = this.recipeModel.$.unitStock
        this.form.meta.units.data = this.units.data.filter(x => x.magnitude === this.recipeModel.$.unitStock.magnitude)
        if (val.uuid) await this.load()
      }
    }
  },
  mounted () {
    window.addEventListener('keydown', this.keyDownHandler)
  },
  destroyed () {
    window.removeEventListener('keydown', this.keyDownHandler)
  },
  methods: {
    keyDownHandler (event) {
      if (event.code === 'Escape') this.$emit('closeIngredientDialog')
    },
    print () {
      window.print()
    },
    async updateProduction () {
      this.overlay = true
      this.recipeModel.set({
        area: (this.recipeModel.area && this.recipeModel.area.id)
          ? this.recipeModel.area.id
          : this.recipeModel.area,
        unitStock: (this.form.data.unit && this.form.data.unit.id)
          ? this.form.data.unit.id
          : this.form.data.unit,
        production: this.form.data.production
      })
      try {
        await this.recipeModel.save()
        this.$toasted.show('La producción se cambió con éxito', { duration: 3000 })
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    updateIngridient: async function (item) {
      try {
        await this.$api.post(
          `/v1/recipes/${this.recipe.uuid}/ingredients/${item.uuid}`, {
            quantity: item.quantity,
            unit: item.unit.id
          }
        )
        this.load()
        this.loadRecipe()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
    },
    activateUnitsMenu () {
      this.$refs.units.activateMenu()
    },
    activateProvidersMenu () {
      this.$refs.providers.activateMenu()
    },
    updatePage (page) {
      this.table.page = page
    },
    nextPage: async function (data) {
      if (this.recipe.uuid) {
        await this.load({
          limit: data.itemsPerPage,
          skip: (data.itemsPerPage * (data.page - 1))
        })
      }
    },
    async loadRecipe () {
      const { response } = await this.recipeModel.detail()
      this.recipeModel.set(response.data)
      this.selectedRecipe = this.recipeModel
      this.form.data.unit = this.selectedRecipe.$.unitStock
      this.form.data.production = this.selectedRecipe.$.production
    },
    load: async function (params = null) {
      params = params || {
        limit: this.table.limit,
        skip: (this.table.limit * (this.table.page - 1))
      }
      this.table.loading = true
      try {
        const { response } = await this.recipeModel.getIngredients()
        this.table.data = response.data.data
        this.table.total = response.total
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.table.loading = false
    },
    openUpdateDialog: async function (ingredient) {
      try {
        await this.productSelected(ingredient.product)
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.form.data = cloneDeep(ingredient)
      this.form.data.recipe = cloneDeep(this.recipe)
      if (ingredient.choice) {
        this.form.data.provider = ingredient.choice.uuid
        this.providerSelected(ingredient.choice.unit)
      }
    },
    async cancel () {
      await this.loadRecipe()
    },
    resetForm () {
      this.form.data.production = this.recipeModel.production
      this.form.data.unit = this.recipeModel.unitStock
    },
    onCloseIngredientsDialog () {
      // this.ingredientToRemove = {}
      // this.resetForm()
      // this.table.total = 0
      // this.table.limit = 15
      // this.table.page = 1
      this.$emit('closeIngredientDialog')
    },
    openRemoveDialog (ingredient) {
      this.ingredientToRemove = cloneDeep(ingredient)
      this.removeDialog = true
    },
    onCloseRemoveDialog () {
      this.ingredientToRemove = {}
      this.removeDialog = false
    },
    fetch: async function (entity, params) {
      return this.$api.get(`/v1/${entity}`, params)
    },
    find (entity, id) {
      return this.$api.get(`/v1/${entity}/${id}`)
    },
    submit: async function () {
      if (this.$refs.ingredientForm.validate()) {
        const request = this.form.data.uuid == null
          ? this.create()
          : this.update()
        this.overlay = true
        try {
          await request
          await this.load()
          this.$refs.ingredientForm.reset()
          this.form.data = { recipe: cloneDeep(this.recipe) }
          this.$toasted.show('La receta se modificó correctamente', { duration: 3000 })
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
      }
      this.resetForm()
      this.loadRecipe()
    },
    create () {
      const payload = cloneDeep(this.form.data)
      payload.choice = payload.provider ? payload.provider.uuid : null
      if (payload.provider == null) {
        payload.subrecipe = payload.product
      }

      if (payload.unit) {
        payload.unit = payload.unit.uuid
      }

      if (payload.product.subrecipe) {
        return this.$api.post(`/v1/recipes/${this.recipe.uuid}/ingredients`, {
          subrecipe: payload.product.uuid,
          quantity: payload.quantity,
          unit: payload.unit
        })
      } else {
        delete payload.provider
        delete payload.product

        return this.$api.post(`/v1/recipes/${this.recipe.uuid}/ingredients`, {
          choice: payload.choice,
          quantity: payload.quantity,
          unit: payload.unit
        })
      }
    },
    update () {
      const payload = cloneDeep(this.form.data)

      if (payload.choice) {
        payload.choice = payload.choice.uuid
      }

      if (payload.unit) {
        payload.unit = payload.unit.uuid
      }

      delete payload.provider
      delete payload.product

      return this.$api
        .post(`/v1/recipes/${this.recipe.uuid}/ingredients/${payload.uuid}`, payload)
    },
    remove: async function () {
      try {
        await this.$api
          .post(`/v1/recipes/${this.recipe.uuid}/ingredients/${this.ingredientToRemove.uuid}/delete`)
        this.$refs.ingredientForm.reset()
        this.load()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.removeDialog = false
      this.loadRecipe()
    }
  }
}
</script>

<style lang="scss" scoped>
.price{
  &-cell {
    position: relative;
  }

  &-tooltip {
    top: 0 !important;
    opacity: 1 !important;
    background: black !important;
  }
}
</style>
